<template>
  <div id="tickets">
    <ticket
     :component-key="componentKey"
     :params="params"
     :pop-ups="popUps"
    />
   
    <table-view
      :component-key="componentKey"
      :end-point="endPoint"
      :column-defs="columnDefs"
      :call-url="callUrl"
      :pop-ups="popUps"
      :buttons="buttons"
      :form-params="params"
      :filters="filters"
      
      >
    </table-view>
  </div>
</template>

<script>
import Ticket from '../../components/forms/Ticket.vue';

import tableView from '../../components/tableView';
export default {
  components: {   
    tableView,
    Ticket
  },
  data() {
    
    let data = {
     componentKey: 0,
     filters: {disable: true},
      popUps:{popupAddActive: false},
      params:{title:'',formType:'add',spaceSelect:null,propertySelect:null},
      lineDetails:{},
      endPoint:'tickets',
      callUrl: '/api/tickets?getTable',
      buttons:{
          addForm: true,
          assign_agent: true,
      },
    }
    
    let firstColumns = {
       headerName: 'Select',
       field: 'select',
        
       width: 125,
       checkboxSelection: true,
       headerCheckboxSelectionFilteredOnly: true,
       headerCheckboxSelection: true,
       
     }
 

    data.columnDefs= JSON.parse(localStorage.getItem('ticketColumns'))

    data.columnDefs.unshift(firstColumns);

    let statusColumn = data.columnDefs.find(column => column.headerName === 'status');
    if (statusColumn) {
            statusColumn.cellStyle = function(params) {
                switch (params.value) {
                    case 'closed':
                        return { color: 'green' };
                    case 'in progress':
                        return { color: 'blue' }; // Changed 'primary' to 'blue' for valid color
                    default:
                        return { color: 'red' };
                }
            };
        }
    return data;
  },
  methods: {
    
  }
}

</script>
